import { BaseQueryFn, createApi, FetchArgs, fetchBaseQuery, FetchBaseQueryError } from '@reduxjs/toolkit/query/react';

import { authenticationApi, FETCH_TOKEN_FIXED_CACHE_KEY } from 'src/api/authentication-api/authentication-api';
import { NavigationService, navigationService } from 'src/services/navigation-service';
import { RootState } from 'src/state/types';

const NO_REDIRECT_TO_ERROR_PAGE_ENDPOINTS = ['getPartners', 'logout'];

const baseQuery = fetchBaseQuery({
  baseUrl: process.env.PUBLIC_URL,

  prepareHeaders: (headers, { getState }) => {
    const rootState: RootState = getState() as RootState;
    const fetchTokenQueryState = authenticationApi.endpoints.fetchToken.select({
      fixedCacheKey: FETCH_TOKEN_FIXED_CACHE_KEY,
      requestId: undefined,
    })(rootState);

    const accessToken = fetchTokenQueryState.data?.access_token;

    if (accessToken) {
      headers.set('Authorization', `Bearer ${accessToken}`);
    }

    return headers;
  },
});

const baseQueryWithHandledErrors: BaseQueryFn<string | FetchArgs, unknown, FetchBaseQueryError> = async (
  args,
  api,
  extraOptions,
) => {
  const result = await baseQuery(args, api, extraOptions);

  if (!NO_REDIRECT_TO_ERROR_PAGE_ENDPOINTS.includes(api.endpoint) && result.error) {
    const pathToRedirect =
      result.error.status === 401 ? NavigationService.ERROR_SESSION_EXPIRED : NavigationService.ERROR;

    navigationService.replacePath(pathToRedirect);
  }

  return result;
};

export const backendApi = createApi({
  baseQuery: baseQueryWithHandledErrors,
  keepUnusedDataFor: Number.MAX_SAFE_INTEGER,
  endpoints: () => ({}),
});
